/**
 * @generated SignedSource<<450d62048a00a7671a0495c232f885c6>>
 * @relayHash f0145d2844cb31576b9be51e3b4df41d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b2a7906eff37e0caa37a462044732c692e9ba5599a2b0e93eb2b126520f4761b

import type { ConcreteRequest } from 'relay-runtime';
export type HomeRecentCreatedQuery$variables = {
  after?: string | null;
  cql: string;
  cqlcontext: string;
  first?: number | null;
};
export type HomeRecentCreatedQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly blank: boolean;
        readonly editorVersion: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly excerpt: string;
        readonly history: {
          readonly createdBy: {
            readonly accountId?: string | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly likes: {
          readonly count: number | null;
        } | null;
        readonly links: {
          readonly editui: string | null;
          readonly webui: string | null;
        } | null;
        readonly metadata: {
          readonly comments: {
            readonly commentsCount: number | null;
          } | null;
          readonly createdDate: string | null;
          readonly currentuser: {
            readonly favourited: {
              readonly isFavourite: boolean | null;
            } | null;
          } | null;
        };
        readonly space: {
          readonly alias: string | null;
          readonly id: string | null;
          readonly key: string | null;
          readonly name: string | null;
        } | null;
        readonly status: string | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
        readonly version: {
          readonly by: {
            readonly accountId?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
};
export type HomeRecentCreatedQuery = {
  response: HomeRecentCreatedQuery$data;
  variables: HomeRecentCreatedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cqlcontext"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "cql",
    "variableName": "cql"
  },
  {
    "kind": "Variable",
    "name": "cqlcontext",
    "variableName": "cqlcontext"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "title"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "ScalarField",
  "name": "subType"
},
v9 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v10 = {
  "args": [
    {
      "kind": "Literal",
      "name": "length",
      "value": 372
    }
  ],
  "kind": "ScalarField",
  "name": "excerpt",
  "storageKey": "excerpt(length:372)"
},
v11 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
      "kind": "LinkedField",
      "name": "currentuser",
      "plural": false,
      "selections": [
        {
          "concreteType": "FavouritedSummary",
          "kind": "LinkedField",
          "name": "favourited",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavourite"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "commentsCount"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "createdDate"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    (v5/*: any*/),
    (v12/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ]
},
v14 = {
  "concreteType": "LikesResponse",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "count"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "status"
},
v16 = {
  "kind": "ScalarField",
  "name": "blank"
},
v17 = {
  "kind": "ScalarField",
  "name": "value"
},
v18 = {
  "alias": "editorVersion",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "editor"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v12/*: any*/),
        (v17/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(key:\"editor\")"
},
v19 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v17/*: any*/),
        (v12/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\"])"
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v21 = [
  (v20/*: any*/)
],
v22 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v23 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeRecentCreatedQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v4/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v21/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": (v21/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v22/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeRecentCreatedQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v4/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v23/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": (v23/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v22/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f0145d2844cb31576b9be51e3b4df41d",
    "id": "b2a7906eff37e0caa37a462044732c692e9ba5599a2b0e93eb2b126520f4761b",
    "metadata": {},
    "name": "HomeRecentCreatedQuery",
    "operationKind": "query",
    "text": "query HomeRecentCreatedQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{content{id,title,type,subType,links{webui,editui},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},createdDate},space{alias,id,key,name},likes{count},status,blank,editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\"]){nodes{id,value,key}},history{createdBy{__typename,...on KnownUser{accountId}}},version{by{__typename,...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
  }
};
})();

(node as any).hash = "85d080eebc369ed2623af7fb67441257";

export default node;
